export const NOT_APPLICABLE_LABEL = 'N/A'

export function isScorable(score: unknown): boolean {
  if (typeof score === 'number') return Number.isFinite(score)
  if (typeof score !== 'string' || score.trim() === '') return false
  return Number.isFinite(Number(score))
}

export function formatScore(score: unknown, maxScore: unknown): string {
  return isScorable(score) ? `${score}/${maxScore}` : NOT_APPLICABLE_LABEL
}
